import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { Box, Button, Grid, Skeleton } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { pdfjs } from "react-pdf";
import { DocumentUrl } from "../../models/cartable.model";
import { ParentLoanComment, Receivers } from "../../models/chat.model";
import ChatMenu from "./chatMenu";
import RepliedCard from "./repliedCard";
// import { worker } from "../../../../node_modules/pdfjs-dist/build/pdf.worker";

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

interface Props {
  chatBorder: "reciver" | "sender";
  avatarGender: string;
  message: string;
  userTitle?: string;
  date: string;
  files: DocumentUrl[];
  referenceKey: string;
  messageKey: string;
  isSender: boolean;
  canBeDeleted: boolean;
  refMessageKey: string;
  mentionUsers: any;
  setRefreshOnDel: any;
  repliedMessage: ParentLoanComment | null;
  receivers: Receivers[];
  setRefreshOnSendCap: any;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function ChatCard({
  chatBorder,
  avatarGender,
  message,
  userTitle,
  date,
  files,
  referenceKey,
  messageKey,
  isSender,
  canBeDeleted,
  refMessageKey,
  mentionUsers,
  setRefreshOnDel,
  repliedMessage,
  receivers,
  setRefreshOnSendCap,
}: Props) {
  const [showMore, setShowMore] = React.useState(false);
  const [isCopied, setCopied] = React.useState(false);
  const [numPages, setNumPages] = React.useState<number>();
  const [pageNumber, setPageNumber] = React.useState<number>(1);

  const text = message;
  const maxChars = 150;

  const handleCopyMassage = () => {
    navigator.clipboard.writeText(message);
    setCopied(true);
  };
  const openInNewTab = (url: any) => {
    const newWindow = window.open(
      `${url}/true`,
      "_blank",
      "noopener,noreferrer"
    );
    if (newWindow) newWindow.opener = null;
  };
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  // pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  //   "../../../../node_modules/pdfjs-dist/build/pdf.worker.min.js",
  //   import.meta.url
  // ).toString();
  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }
  return (
    <div
      style={{ width: "100%" }}
      className={
        chatBorder === "sender" ? "senderContainer" : "reciverContainer"
      }
    >
      <Card
        sx={{
          maxWidth: 345,
          direction: "rtl",
          background: "#34495E !important",
          color: "#fff",
          border: "none",
          minHeight: "80px",
          paddingX: "1rem",
          overflow: "initial !important",
          width: { xs: "80%", sm: "70%" },
        }}
        className={chatBorder === "sender" ? "senderStyle" : "resiverStyle"}
      >
        {repliedMessage !== null ? (
          <div className="replied-message">
            <RepliedCard
              messageText={repliedMessage.messageText}
              fullName={repliedMessage.creatorPersonInfo.fullName}
              gender={repliedMessage.creatorPersonInfo.genderType}
              repliedFiles={repliedMessage.files}
            />
          </div>
        ) : null}
        {isSender === false ? (
          <CardHeader
            color="#fff !important"
            className="chat-header"
            sx={{
              borderBottom: "1px solid rgba(255,255,255,.1)",
              paddingY: "0px !important",
              paddingRight: "0px !important",
            }}
            avatar={
              <Avatar
                className="chat-card-avatar"
                sx={{
                  bgcolor: "E5E1DA",
                  marginLeft: "7px",
                }}
                aria-label="recipe"
              >
                {avatarGender.toLocaleLowerCase() === "female" ? (
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src="images/person_3_black_24dp.svg"
                    alt="female user"
                  />
                ) : (
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src="images/person_black_24dp.svg"
                    alt="male user"
                  />
                )}
              </Avatar>
            }
            action={
              <IconButton aria-label="settings" className="chatCardOptions">
                <ChatMenu
                  referenceKey={referenceKey}
                  messageKey={messageKey}
                  handleCopyMassage={handleCopyMassage}
                  isCopied={isCopied}
                  canBeDeleted={canBeDeleted}
                  refMessageKey={refMessageKey}
                  mentionUsers={mentionUsers}
                  message={message}
                  userTitle={userTitle}
                  avatarGender={avatarGender}
                  isSender={isSender}
                  setRefreshOnDel={setRefreshOnDel}
                  setRefreshOnSendCap={setRefreshOnSendCap}
                  replyFiles={files}
                />
              </IconButton>
            }
            title={<span style={{ color: "#fff" }}>{userTitle}</span>}
          />
        ) : (
          <CardHeader
            color="#fff !important"
            sx={{ height: "0px", padding: "0 !important" }}
            action={
              <IconButton
                aria-label="settings"
                className="chatCardOptions-noAvatar"
              >
                <ChatMenu
                  referenceKey={referenceKey}
                  messageKey={messageKey}
                  handleCopyMassage={handleCopyMassage}
                  isCopied={isCopied}
                  canBeDeleted={canBeDeleted}
                  refMessageKey={refMessageKey}
                  mentionUsers={mentionUsers}
                  message={message}
                  userTitle={userTitle}
                  avatarGender={avatarGender}
                  isSender={isSender}
                  setRefreshOnDel={setRefreshOnDel}
                  setRefreshOnSendCap={setRefreshOnSendCap}
                  replyFiles={files}
                />
              </IconButton>
            }
          />
        )}
        <CardContent
          sx={{
            marginTop: "10px",
            paddingTop: "4px",
            paddingBottom: "10px !important",
            paddingX: "3px !important",
          }}
        >
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            // marginBottom={"20px"}
          >
            <Grid item xs={10} textAlign={"center"}>
              {files.map(
                (file) =>
                  file !== null &&
                  (file.fileType.toLocaleLowerCase() === "image" ? (
                    <div
                      style={{ marginBottom: "10px" }}
                      // className="chatCard-imagePrev-container"
                    >
                      <LazyLoadImage
                        wrapperProps={{
                          // If you need to, you can tweak the effect transition using the wrapper style.
                          style: { transitionDelay: "1s" },
                        }}
                        style={{
                          objectFit: "contain",
                          marginTop: "5px",
                          marginBottom: "5px",
                          cursor: "pointer",
                        }}
                        src={
                          file.thumbnailFileUrl !== null
                            ? file.thumbnailFileUrl
                            : file.fileUrl
                        }
                        alt={file.fileName}
                        effect="blur"
                        // className="chatCard-imagePrev"
                        width={260}
                        height={180}
                        onClick={() => {
                          openInNewTab(file.fileUrl);
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        marginTop: "5px",
                        marginBottom: "5px",
                        cursor: "pointer",
                      }}
                    >
                      {file.fileType.toLocaleLowerCase() === "pdf" && (
                        <a href={file.fileUrl} target="_blank">
                          <PictureAsPdfOutlinedIcon
                            className={"uploadImageCmpIconPDF"}
                            // style={{ marginTop: "1vh" }}
                          />
                        </a>
                      )}
                      {file.fileType.toLocaleLowerCase() === "zip" && (
                        <a href={file.fileUrl} target="_blank">
                          <FolderZipOutlinedIcon
                            className={"uploadImageCmpIconPDF"}
                            // style={{ marginTop: "1vh" }}
                          />
                        </a>
                      )}
                      {file.fileType.toLocaleLowerCase() !== "pdf" &&
                        file.fileType.toLocaleLowerCase() !== "zip" && (
                          <a href={file.fileUrl} target="_blank">
                            <InsertDriveFileOutlinedIcon
                              className={"uploadImageCmpIconPDF"}
                              // style={{ marginTop: "1vh" }}
                            />
                          </a>
                        )}
                    </div>
                  ))
              )}
            </Grid>
          </Grid>
          <Box marginTop={"10px"}>
            {receivers.map((receiver) => (
              <Typography
                display={"block"}
                color={"#18FFFF"}
                marginBottom={"10px"}
              >
                @ {receiver.fullName}
              </Typography>
            ))}
            {text !== null && (
              <Typography
                variant="body2"
                color="#fff"
                lineHeight={"1.5rem"}
                fontSize={"13px"}
                marginBottom={"7px"}
                textAlign={"justify"}
                sx={{ wordWrap: "break-word", width: "250px" }}
              >
                {showMore ? text : `${text.substring(0, maxChars)}`}
                {text.length >= maxChars && (
                  <Button
                    onClick={() => setShowMore(!showMore)}
                    sx={{
                      position: "static !important",
                      color: "#18FFFF",
                      padding: "0 !important",
                      marginTop: "4px",
                    }}
                  >
                    {showMore ? "کمتر" : "بیشتر"}
                  </Button>
                )}
              </Typography>
            )}

            <Typography
              variant="body2"
              color="#E8EAF6"
              sx={{
                direction: "ltr",
                textAlign: "left",
                marginTop: "2rem",
                paddingBottom: "10px !important",
                marginLeft: "-5px",
              }}
            >
              {date}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}
